import { useSequencesContext } from '../SequencesContext';
import type { StepsType } from './useSequences';

export function useSteps(step: StepsType) {
	const {
		selectedStep,
		setSelectedStep,
		selectedTemplate,
		setSelectedTemplate,
		selectedSequence,
		setSelectedSequence
	} = useSequencesContext();

	function handleRemoveStep() {
		if (!selectedStep || !selectedTemplate || !selectedSequence) return;
		const newSteps = selectedTemplate?.steps.filter(s => s.id !== step.id);
		const stepsReordered = newSteps.map((s, i) => {
			return {
				...s,
				order: i
			};
		});
		setSelectedTemplate({
			...selectedTemplate,
			steps: stepsReordered
		});
		setSelectedSequence({
			...selectedSequence,
			steps: stepsReordered
		});
	}

	function handleMoveStepDown() {
		if (!selectedStep || !selectedTemplate || !selectedSequence) return;
		const newSteps = selectedTemplate?.steps.map(s => {
			if (s.order === step.order) {
				return {
					...s,
					order: s.order + 1
				};
			}
			if (s.order === step.order + 1) {
				return {
					...s,
					order: s.order - 1
				};
			}
			return s;
		});
		setSelectedTemplate({
			...selectedTemplate,
			steps: newSteps
		});
		setSelectedSequence({
			...selectedSequence,
			steps: newSteps
		});
		setSelectedStep({ ...step, order: step.order + 1 });
	}

	function handleMoveStepUp() {
		if (!selectedStep || !selectedTemplate || !selectedSequence) return;
		const newSteps = selectedTemplate?.steps.map(s => {
			if (s.order === step.order) {
				return {
					...s,
					order: s.order - 1
				};
			}
			if (s.order === step.order - 1) {
				return {
					...s,
					order: s.order + 1
				};
			}
			return s;
		});
		setSelectedTemplate({
			...selectedTemplate,
			steps: newSteps
		});
		setSelectedSequence({
			...selectedSequence,
			steps: newSteps
		});
		setSelectedStep({ ...step, order: step.order - 1 });
	}

	function handleDuplicateStep() {
		if (!selectedTemplate || !selectedSequence) return;
		const duplicatedStep = {
			...step,
			sendAfterInterval: step.order === 0 ? 1 : step.sendAfterInterval,
			order: selectedTemplate?.steps.length
		};
		const newSteps = [...selectedTemplate?.steps, duplicatedStep];
		setSelectedTemplate({
			...selectedTemplate,
			steps: newSteps
		});
		setSelectedSequence({
			...selectedSequence,
			steps: newSteps
		});
		setSelectedStep(duplicatedStep);
	}

	const stepDropdownMenuOptions = [
		{
			id: 'duplicate',
			label: 'Duplicate',
			onClick: handleDuplicateStep
		},
		{
			id: 'moveup',
			label: 'Move Up',
			onClick: handleMoveStepUp,
			disabled: step.order === 0 || step.order === 1
		},
		{
			id: 'movedown',
			label: 'Move Down',
			onClick: handleMoveStepDown,
			disabled:
				step.order === 0 ||
				step.order === (selectedTemplate?.steps.length || 0) - 1
		},
		{
			id: 'remove',
			label: 'Remove',
			onClick: handleRemoveStep,
			disabled: step.order === 0
		}
	];

	return {
		stepDropdownMenuOptions
	};
}
